"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UploadInputModule = _interopRequireDefault(require("./UploadInput.module.scss"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function UploadInput(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      loading = _ref.loading,
      loadingText = _ref.loadingText,
      message = _ref.message,
      value = _ref.value,
      validation = _ref.validation,
      innerRef = _ref.innerRef,
      preview = _ref.preview,
      onChange = _ref.onChange;
  var inputRef = (0, _react.useRef)(null);
  var handleRef = (0, _react.useCallback)(function (node) {
    if (innerRef) {
      innerRef.current = node;
    }

    inputRef.current = node;
  }, [inputRef, innerRef]);
  var classes = (0, _classnames.default)(_UploadInputModule.default.inputBlock, disabled && _UploadInputModule.default.disabled, validation === "success" && _UploadInputModule.default.success || validation === "warning" && _UploadInputModule.default.warning || validation === "error" && _UploadInputModule.default.error, value && _UploadInputModule.default.nonEmpty);
  return _react.default.createElement("div", {
    className: classes
  }, label && _react.default.createElement("label", {
    className: _UploadInputModule.default.label
  }, label), _react.default.createElement("div", {
    className: _UploadInputModule.default.inputContainer
  }, preview && _react.default.createElement("div", {
    className: _UploadInputModule.default.filePreview
  }, preview), _react.default.createElement(_Button.default, {
    processing: loading,
    processingText: loadingText,
    onClick: function onClick() {
      return inputRef.current.click();
    },
    outline: true
  }, "Upload"), _react.default.createElement("input", {
    ref: handleRef,
    type: "file",
    className: _UploadInputModule.default.fileInput,
    onChange: onChange
  })), message && validation && !disabled && _react.default.createElement("div", {
    className: _UploadInputModule.default.validationMessage
  }, message));
}

UploadInput.propTypes = {
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  validation: _propTypes.default.string,
  loading: _propTypes.default.bool,
  loadingText: _propTypes.default.string,
  message: _propTypes.default.string,
  value: _propTypes.default.string,
  preview: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired
};
UploadInput.defaultProps = {
  disabled: false,
  loading: false,
  loadingText: "Uploading...",
  label: "",
  validation: "",
  message: ""
};
var _default = UploadInput;
exports.default = _default;